export const FORM_MIN_WIDTH = 270;
